import { render, staticRenderFns } from "./ThanksSection.vue?vue&type=template&id=20e0ce42"
import script from "./ThanksSection.vue?vue&type=script&lang=js"
export * from "./ThanksSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports